import React, { useMemo } from 'react';

import StatCard from '../../common/StatCard/StatCard';

import usePrometheusQuery from '../../../utils/hooks/use_prometheus_query_without_range';
import { percentFormatter } from '../../../utils/formatters';
import { CPUIcon } from '../../common/icons/CPUIcon';
import Icon from '../../common/icons/Icon';
import COLORS from '../../../constants/colors.constants';

const getRequestedGPUQuery = () => {
  return 'sum(wallaroo_kube_pod_resource_requests{resource=~"nvidia.com/gpu"})';
}

const getTotalGPUQuery = () => {
  return 'sum(kube_node_status_capacity{resource=~"nvidia_com_gpu"})';
}

const CPUIconComponent = () => {
  return <Icon fill={COLORS.brand} icon={CPUIcon} size={24} useTailwindSizing />
}

export const useTotalGPU = () => {
  const query = useMemo(() => {
    return getTotalGPUQuery();
  }, [])
  const prometheusResponse = usePrometheusQuery(query);

  return {
    chartData: prometheusResponse?.data,
    isLoading: prometheusResponse?.isLoading,
    message: prometheusResponse?.error || null,
  }
}

export const useRequestedGPU = () => {
  const query = useMemo(() => {
    return getRequestedGPUQuery();
  }, [])
  const prometheusResponse = usePrometheusQuery(query);

  return {
    chartData: prometheusResponse?.data,
    isLoading: prometheusResponse?.isLoading,
    message: prometheusResponse?.error || null,
  }
}

export const ContextualTotalGPUCard = () => {
  const requestedResponse = useRequestedGPU()
  const requestedData = requestedResponse?.chartData;
  const requestedValue = requestedData?.length ? requestedData[1] : 0;

  const totalResponse = useTotalGPU()
  const totalData = totalResponse?.chartData;
  const totalValue = totalData?.length ? totalData[1] : 0;

  const subtitle = `Requested ${requestedValue}/${totalValue} GPUs Allocated`;

  const content = totalValue ? percentFormatter.format(requestedValue / totalValue) : 0;

  const isLoading = requestedResponse?.isLoading || totalResponse?.isLoading;

  return (
    <StatCard
      className=""
      icon={CPUIconComponent}
      header="Total GPU Currently Requested"
      subtitle={subtitle}
      content={`${content}`}
      isLoading={isLoading}
    />
  )
}

export default ContextualTotalGPUCard;
